//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { DEFAULT_EMPTY_VALUE } from '@campaigns/components/campaigns-requests/creator-campaigns/CreatorsCampaignRequestDetailsConstants';
import { ProductDetailsFieldLabels } from '@campaigns/constants/ProductDetailsModalFieldLabels';
import { BodyText } from '@components/atoms/text/Text';

interface ProductMetaFieldsViewOnlyProps {
  brand?: string;
  category?: string;
  pdpUrl?: string;
}

export const ProductMetaFieldsViewOnly = ({
  brand,
  category,
  pdpUrl,
}: ProductMetaFieldsViewOnlyProps) => {
  return (
    <Container>
      <FieldContainer>
        <BodyText>{ProductDetailsFieldLabels.brand}</BodyText>
        <BodyText>{brand ?? DEFAULT_EMPTY_VALUE}</BodyText>
      </FieldContainer>
      <FieldContainer>
        <BodyText>{ProductDetailsFieldLabels.category}</BodyText>
        <BodyText>{category ?? DEFAULT_EMPTY_VALUE}</BodyText>
      </FieldContainer>
      <FieldContainer>
        <BodyText>{ProductDetailsFieldLabels.pdpUrl}</BodyText>
        <BodyText>{pdpUrl ?? DEFAULT_EMPTY_VALUE}</BodyText>
      </FieldContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[3]};
`;

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[1]};
`;
